import { useTranslation } from "react-i18next";
import { Alert } from "@/components/ui";

/** Shown above the settings form while required profile data is missing. */
export function ProfileStatusBanner() {
  const { t } = useTranslation("settings");

  return (
    <Alert
      variant="warning"
      title={t("forms.profileStatus.incompleteTitle")}
    >
      {t("forms.profileStatus.incompleteDesc")}
    </Alert>
  );
}
